import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule, DatePipe} from '@angular/common';
import { CommonScreenComponent } from 'src/app/components/side-screen/common-screen/common-screen.component';
import { FusionButtonComponent } from '../fusion-button/fusion-button.component';
import { DataTableComponent } from '../data-table/data-table.component';
import { ActivatedRoute } from '@angular/router';
import { CardsComponent } from '../cards/cards.component';
import { GlobalValuesService } from 'src/app/services/global-values.service';

@Component({
  selector: 'app-right-nav',
  standalone: true,
  imports: [
    CommonModule,
    CommonScreenComponent,
    FusionButtonComponent,
    DataTableComponent,
    CardsComponent
  ],
  templateUrl: './right-nav.component.html',
  styleUrls: ['./right-nav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush //SKS5OCT24 to avoid re-rendering of the component
})
export class RightNavComponent implements OnInit, OnChanges {
  @Input() sideNavData: any;  

  sideScreen: boolean = false;  
  moduleName: any;
  tabName: any;
  displayedTabContent: any;
  tab: any;
  cardData: any;
  appName: any;

  constructor( private routeActive: ActivatedRoute, private datePipe: DatePipe, private globalValues: GlobalValuesService) { 
      let tabFiltered:any;
      this.routeActive.paramMap.subscribe((params: { get: (arg0: string) => any; }) => { ///SKS5OCT24 to get the tab name from the current route
        this.appName = params.get('appName');
        this.moduleName = params.get('moduleName');
        this.tabName = params.get('tabName');
        this.displayedTabContent = this.tabName;
        const userDataConst:any = localStorage.getItem('userData');
        if(userDataConst) {  //SKS5OCT24 get the browse tabs config from local storage
          const module = JSON.parse(localStorage.getItem("browseTabs") as any);
          if(this.moduleName === module?.name){
            tabFiltered = module?.tabs?.filter((tabFilter:any) => tabFilter.name === this.tabName);
            this.tab = tabFiltered[0]['sideNavConfig']; //SKS5OCT24 to get the side nav config from local storage
          } 
        } 
      });
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sideNavData'] && changes['sideNavData'].currentValue ) {
      if(this.sideNavData){ //SKS5OCT24 if the side nav config is available then process the data
        this.processData(this.tab)
      }
    }
  }
  //SKS5OCT24 process the side nav config and display the data
  async processData(selTab:any){
    this.displayedTabContent = selTab?.name; //SKS5OCT24 to get the tab name from the side nav config for selected tab
    if(selTab?.components != undefined){
      selTab.components.forEach((comps:any) => {
        if (comps?.type === 'card'){ //SKS5OCT24 process the card data
          this.cardData = comps.config.cardList;
          this.cardData.forEach((cardDatum:any) => {
            cardDatum.config.details.forEach((fieldsValue:any) => {
              cardDatum.config.data = {};
              fieldsValue.value = this.globalValues.getValue(this.sideNavData, fieldsValue.RF);
              cardDatum.config.data[fieldsValue.refField] = fieldsValue.value;
            });
          }); 
        } else if (comps?.type === 'table'){ //SKS5OCT24 process the table data
          comps.config.data = [];
          comps.config.data = this.sideNavData[comps?.config?.name];
        }
      });
    } 
  }
  openRightNav() {  //SKS5OCT24 to open the side nav
    this.sideScreen = true;
  }
}
